var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_center lawEnforcementList" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("div", { staticClass: "search-content" }, [
          _c(
            "div",
            { staticClass: "mainBtn" },
            [
              _vm.hasBtnPermission("btn_extract_configurationItem_add")
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.routerAdd()
                        },
                      },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "searchBtn" },
            [
              _c("span", { staticClass: "label-form" }, [_vm._v("配置编号：")]),
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "", placeholder: "请输入内容搜索" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchBtn.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.form.configCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "configCode", $$v)
                  },
                  expression: "form.configCode",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "12px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.searchBtn },
                },
                [_vm._v("搜索")]
              ),
              _c("el-divider", { attrs: { direction: "vertical" } }),
              _c("el-button", {
                attrs: { icon: "el-icon-refresh", type: "text" },
                on: { click: _vm.refresh },
              }),
            ],
            1
          ),
        ]),
        _vm.addDialog
          ? [
              _c("extractConfigurationItem-detail", {
                ref: "extractConfigurationItem",
                on: { handleClose: _vm.handleClose },
              }),
            ]
          : _vm._e(),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.dataListLoading,
                expression: "dataListLoading",
              },
            ],
            ref: "multipleTable",
            staticClass: "table-content",
            attrs: {
              data: _vm.tableData,
              "header-cell-style": this.$globalGrayTableHeaderStyle,
              height: _vm.tableMaxHeight,
              stripe: "",
              border: "",
            },
          },
          [
            _vm.hasBtnPermission("btn_extract_configurationItem_del")
              ? _c("el-table-column", {
                  attrs: { fixed: "", type: "selection", align: "center" },
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                fixed: "",
                label: "序号",
                type: "index",
                width: "50",
                align: "center",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "配置编号",
                prop: "configCode",
                "header-align": "center",
                align: "center",
                width: "150",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "检查适用部门",
                prop: "usableDeptCodeName",
                "header-align": "center",
                align: "left",
                "min-width": "90",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "执法检查类型",
                prop: "checkTypeName",
                align: "center",
                width: "150",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "更新人",
                prop: "updateUser",
                "header-align": "center",
                align: "left",
                width: "150",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "更新日期",
                prop: "updateTime",
                "header-align": "center",
                align: "center",
                width: "120",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "创建时间",
                prop: "createTime",
                "header-align": "center",
                align: "center",
                width: "120",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "状态",
                prop: "useStatus",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.useStatusName))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "有效期",
                prop: "status",
                "header-align": "center",
                align: "center",
                "min-width": "100",
                "show-overflow-tooltip": true,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(scope.row.startTime, "yyyy-MM-dd")
                          ) +
                            " - " +
                            _vm._s(
                              _vm.formatDate(scope.row.endTime, "yyyy-MM-dd")
                            )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                fixed: "right",
                align: "center",
                width: "180",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.hasBtnPermission("btn_extract_configurationItem_add")
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.router(scope.row)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.hasBtnPermission("btn_extract_configurationItem_add")
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.router(scope.row, true)
                                },
                              },
                            },
                            [_vm._v("复制修改")]
                          )
                        : _vm._e(),
                      _vm.hasBtnPermission("btn_extract_configurationItem_del")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                size: "small",
                                title: "删除",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteById(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("paginationCom", {
          staticClass: "limit",
          attrs: { options: _vm.paginationOpt },
          on: {
            sizechange: _vm.sizeChangeHandle,
            pagechange: _vm.pageChangeHandle,
          },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }